import {FC, MouseEventHandler, useRef} from 'react';
import {mergeProps, useFocusRing, useTableCell} from 'react-aria';
import {Node, TableState} from 'react-stately';
import clsx from 'clsx';
import TableStaticCell from 'components/Table/TableStatic/TableStaticCell';

type TableCellProps = {
    cell: Node<object>;
    state: TableState<unknown>;
};

const TableCell: FC<TableCellProps> = ({cell, state}) => {
    const {className, colSpan, preventPointerEvents} = cell.props;
    const ref = useRef(null);
    const {gridCellProps} = useTableCell({node: cell}, state, ref);
    const {focusProps} = useFocusRing();

    const pointerEvents: Record<
        string,
        MouseEventHandler<unknown>
    > = preventPointerEvents
        ? {
              onMouseDown: (event) => {
                  event.stopPropagation();
              },
              onPointerDown: (event) => {
                  event.stopPropagation();
              },
          }
        : {};

    return (
        <TableStaticCell
            {...mergeProps(gridCellProps, focusProps)}
            ref={ref}
            className={clsx('select-text', className)}
            colSpan={colSpan}
            {...pointerEvents}
        >
            {cell.rendered}
        </TableStaticCell>
    );
};

export default TableCell;
